module.exports = {
  "country": "NL",
  "artist": "Teddy Scholten",
  "song": "Een Beetje",
  "year": "1959",
  "place": "1",
  "spotify": "6fQfOgajFEdUTOvAQNoinK"
};